import { render, staticRenderFns } from "./FullEvent.vue?vue&type=template&id=fcb80946&"
import script from "./FullEvent.vue?vue&type=script&lang=js&"
export * from "./FullEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports